let ctx;

const getCtx = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

export const playNotify = () => {
  try {
    const c = getCtx();
    const t = c.currentTime;
    const gain = c.createGain();
    gain.gain.setValueAtTime(0.001, t);
    gain.gain.exponentialRampToValueAtTime(0.22, t + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, t + 0.6);
    gain.connect(c.destination);
    [880, 1174.66].forEach((f, i) => {
      const o = c.createOscillator();
      o.type = "sine";
      o.frequency.setValueAtTime(f, t + i * 0.12);
      o.connect(gain);
      o.start(t + i * 0.12);
      o.stop(t + i * 0.12 + 0.25);
    });
  } catch { /* audio diblokir browser sampai interaksi pertama */ }
};

// Suara khusus request saldo (deposit) — arpeggio naik 4 nada, berbeda dari notifikasi chat/FUP
export const playDepositNotify = () => {
  try {
    const c = getCtx();
    const t = c.currentTime;
    const gain = c.createGain();
    gain.gain.setValueAtTime(0.001, t);
    gain.gain.exponentialRampToValueAtTime(0.25, t + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, t + 0.9);
    gain.connect(c.destination);
    [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => {
      const o = c.createOscillator();
      o.type = "triangle";
      o.frequency.setValueAtTime(f, t + i * 0.11);
      o.connect(gain);
      o.start(t + i * 0.11);
      o.stop(t + i * 0.11 + 0.22);
    });
  } catch { /* audio diblokir browser sampai interaksi pertama */ }
};


// Suara khusus tagihan portal (transfer pelanggan) — "ka-ching" dua nada tinggi cepat + nada panjang
export const playPortalNotify = () => {
  try {
    const c = getCtx();
    const t = c.currentTime;
    const gain = c.createGain();
    gain.gain.setValueAtTime(0.001, t);
    gain.gain.exponentialRampToValueAtTime(0.28, t + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, t + 1.1);
    gain.connect(c.destination);
    [[1318.5, 0, 0.12], [1567.98, 0.1, 0.12], [1975.53, 0.2, 0.7]].forEach(([f, d, len]) => {
      const o = c.createOscillator();
      o.type = "square";
      o.frequency.setValueAtTime(f, t + d);
      o.connect(gain);
      o.start(t + d);
      o.stop(t + d + len);
    });
  } catch { /* audio diblokir browser sampai interaksi pertama */ }
};


// Nada singkat balasan admin di portal pelanggan (satu "ting" lembut)
export const playPortalReply = () => {
  try {
    const c = getCtx();
    const t = c.currentTime;
    const gain = c.createGain();
    gain.gain.setValueAtTime(0.001, t);
    gain.gain.exponentialRampToValueAtTime(0.2, t + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.001, t + 0.45);
    gain.connect(c.destination);
    const o = c.createOscillator();
    o.type = "triangle";
    o.frequency.setValueAtTime(1318.5, t);
    o.connect(gain);
    o.start(t);
    o.stop(t + 0.45);
  } catch { /* audio diblokir browser sampai interaksi pertama */ }
};

// Suara khusus di-tag admin (@nama) — 3x "ding" cepat nada tinggi agar beda dari chat biasa
export const playMentionNotify = () => {
  try {
    const c = getCtx();
    const t = c.currentTime;
    [0, 0.18, 0.36].forEach((d) => {
      const gain = c.createGain();
      gain.gain.setValueAtTime(0.001, t + d);
      gain.gain.exponentialRampToValueAtTime(0.3, t + d + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, t + d + 0.16);
      gain.connect(c.destination);
      const o = c.createOscillator();
      o.type = "triangle";
      o.frequency.setValueAtTime(1568, t + d);
      o.connect(gain);
      o.start(t + d);
      o.stop(t + d + 0.17);
    });
  } catch { /* audio diblokir browser sampai interaksi pertama */ }
};

// Suara tugas admin — dua nada naik (ding-dong terbalik) agar beda dari chat & deposit
export const playTaskNotify = () => {
  try {
    const c = getCtx();
    const t = c.currentTime;
    [[0, 659.25], [0.22, 987.77]].forEach(([d, f]) => {
      const gain = c.createGain();
      gain.gain.setValueAtTime(0.001, t + d);
      gain.gain.exponentialRampToValueAtTime(0.28, t + d + 0.03);
      gain.gain.exponentialRampToValueAtTime(0.001, t + d + 0.35);
      gain.connect(c.destination);
      const o = c.createOscillator();
      o.type = "sine";
      o.frequency.setValueAtTime(f, t + d);
      o.connect(gain);
      o.start(t + d);
      o.stop(t + d + 0.36);
    });
  } catch { /* audio diblokir browser sampai interaksi pertama */ }
};
